import React from "react";

const FeaturedAdsIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      fill="#000000"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 66 66" 
      xmlSpace="preserve"
      strokeWidth={1}
    stroke="currentColor"
      className={className|| "size-4"}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M59,15H28H16H1c-0.6,0-1,0.4-1,1v43c0,0.6,0.4,1,1,1h58c0.6,0,1-0.4,1-1V16C60,15.4,59.6,15,59,15z M27,17v14H17V17H27z M58,58H43V48h-2v10H2V17h13v15c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1V17h12v16h2V17h15V58z"></path>{" "}
            <rect x="7" y="49" width="9" height="2"></rect>{" "}
            <rect x="7" y="53" width="18" height="2"></rect>{" "}
            <rect x="46" y="20" width="6" height="2"></rect>{" "}
            <rect x="46" y="24" width="9" height="2"></rect>{" "}
            <rect x="49" y="53" width="6" height="2"></rect>{" "}
            <rect x="46" y="49" width="9" height="2"></rect>{" "}
            <path d="M59,0H1C0.4,0,0,0.4,0,1v9c0,0.6,0.4,1,1,1h58c0.6,0,1-0.4,1-1V1C60,0.4,59.6,0,59,0z M58,9H2V2h7v4h2V2h8v4h2V2h8v4h2V2 h8v4h2V2h8v4h2V2h7V9z"></path>{" "}
            <path d="M47.3,45c0.2,0,0.3-0.1,0.5-0.2l6.6-2.8c0.4-0.1,0.6-0.5,0.6-0.9s-0.2-0.7-0.6-0.9l-6.6-2.8c-0.2-0.2-0.4-0.3-0.7-0.3h-40 c-0.6,0-1,0.4-1,1v6c0,0.6,0.4,1,1,1h40C47.1,45,47.2,45,47.3,45z M15,42h31v1H15V42z M48,42.5v-3l3.5,1.5L48,42.5z M46,40H15v-1 h31V40z M8,39h5v4H8V39z"></path>{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

export default FeaturedAdsIcon;
